import type { Destinations } from "@/queries/getDestinations";
import { Fragment } from "react";
import { columns } from "../destinationsGrid/Columns";
import { SMGDestination } from "./SMGDestination";

type Props = {
  destinations: Destinations;
};
export const SMGDestinationGrid = ({ destinations }: Props) => {
  const regions = destinations.map((destination) => ({
    id: destination.id,
    title: destination.title,
    alias: destination.alias,
    places: destination.countries
      .map((child) => ({
        id: child.id,
        title: child.title,
        alias: child.alias,
        departures: child.count,
      }))
      .filter((d) => d.departures !== 0),
  }));

  const europe = regions
    .filter((d) =>
      ["europe-du-sud", "europe-occidentale", "europe-centrale-et-de-l-est", "europe-du-nord"].includes(d.alias),
    )
    .flatMap((d) => d.places)
    .sort((a, b) => a.title.localeCompare(b.title));

  const europe1 = europe.slice(0, 19);
  const europe2 = europe.slice(19);

  return (
    <div className="grid grid-cols-5 gap-x-6">
      <div className="flex flex-col gap-1">
        <p className="font-serif text-pr-1 text-base font-medium">Europe</p>
        {europe1?.map((place) => (
          <SMGDestination key={place.id} destination={place} />
        ))}
      </div>
      <div className="flex flex-col gap-1 pt-6">
        {europe2?.map((place) => (
          <SMGDestination key={place.id} destination={place} />
        ))}
      </div>
      {columns.map((column, index) => {
        return (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <div key={index} className="flex flex-col gap-1">
            {column.map((element) => {
              const dests = regions
                .filter((d) => element.alias.includes(d.alias))
                .flatMap((d) => d.places)
                .sort((a, b) => a.title.localeCompare(b.title));

              if (dests.length === 0) return null;

              return (
                <Fragment key={element.title}>
                  <p className="font-serif text-pr-1 text-base font-medium">{element.title}</p>
                  {dests.map((place) => (
                    <SMGDestination key={place.id} destination={place} />
                  ))}
                </Fragment>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};
